export default __webpack_public_path__ + "static/N0200-6968d15e942f3ccef93898b2fa6a092b.png";